/* global Cookiebot */

export default async function init() {
  // Check if Cookiebot is available
  if (typeof Cookiebot === 'undefined') {
    console.warn('Cookiebot is not loaded');
    return;
  }

  // Initial check
  handleConsent();

  // Listen for consent changes
  window.addEventListener('CookiebotOnAccept', () => handleConsent());
  window.addEventListener('CookiebotOnDecline', () => handleConsent());
}

const handleConsent = () => {
  // Find all Sketchfab iframes using the class identifier
  const sketchfabIframes = document.querySelectorAll('.js-sketchfab-iframe');
  const hasConsent = Cookiebot.consent.preferences && Cookiebot.consent.statistics;

  sketchfabIframes.forEach((iframe) => {
    // Get the data-src value using destructuring
    const { src: dataSrc } = iframe.dataset;
    if (!dataSrc) return;

    // Create a mutable copy of the URL
    let finalSrc = dataSrc;

    // Handle the dnt parameter based on consent
    const url = new URL(finalSrc);
    const params = new URLSearchParams(url.search);

    if (hasConsent) {
      // Remove dnt parameter if it exists
      params.delete('dnt');
    } else {
      // Add dnt=1 parameter if it doesn't exist
      params.set('dnt', '1');
    }

    url.search = params.toString();
    finalSrc = url.toString();

    // Set the src attribute
    iframe.src = finalSrc;
    iframe.removeAttribute('data-src');
  });
}
